module.exports = __webpack_public_path__ + "static/media/IMG-5211.aa4a4810.JPG";